import { Fragment } from "react";

const DEFAULT = [
  "Care Home Dining",
  "School Meals",
  "Corporate Hospitality",
  "Agency Chefs",
  "Flapjack Pancake & Waffle Mix",
  "Cooked Fresh, Served With Care",
];

export const Marquee = ({ items = DEFAULT, dark = false, tone, font = "font-display", star = "text-[#C59B27]" }) => (
  <div
    className={`relative overflow-hidden border-y py-7 ${tone || (dark ? "bg-[#141412] border-white/10 text-[#FAF8F5]" : "bg-[#FAF8F5] border-stone-300/70 text-[#141412]")}`}
    data-testid="editorial-marquee"
  >
    <div className="marquee-track flex w-max items-center whitespace-nowrap">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {items.map((t, i) => (
            <Fragment key={`${k}-${i}`}>
              <span className={`${font} text-3xl sm:text-5xl px-8 ${i % 2 && font === "font-display" ? "italic" : ""}`}>{t}</span>
              <span className={`${star} text-2xl`}>✦</span>
            </Fragment>
          ))}
        </div>
      ))}
    </div>
  </div>
);
